import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { isUrlValid } from 'utils';
import { NO_IMAGE_AVAILABLE } from 'constants';

const Image = ({ src, alt, fallback, userBrand, ...rest }) => {
  const fallbackURL = NO_IMAGE_AVAILABLE[userBrand];
  const sanitizedURL = isUrlValid(src) ? src : fallbackURL;
  const onError = (e) => {
    e.target.src = fallback || fallbackURL;
  };
  return <img src={sanitizedURL} alt={alt} onError={onError} {...rest} />;
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  fallback: PropTypes.string,
  userBrand: PropTypes.string,
};

Image.defaultProps = {
  alt: '',
  userBrand: 'NM',
};

export default memo(Image);
